import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

/** Mesma chave usada em `AuthService` ao gravar o JWT no login. */
const AUTH_TOKEN_STORAGE_KEY = 'authToken';

/**
 * Envia `Authorization: Bearer <jwt>` em todas as requisições HTTP,
 * exceto login/registro/recuperação de senha e APIs públicas externas.
 * Isso garante claims como StaffId, CostCenterId, permission[], etc. no backend.
 */
@Injectable()
export class JwtBearerInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.shouldSkipBearer(request)) {
      return next.handle(request);
    }

    const raw = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
    const token = typeof raw === 'string' ? raw.trim() : '';
    if (!token) {
      return next.handle(request);
    }

    const clone = request.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
    return next.handle(clone);
  }

  private shouldSkipBearer(request: HttpRequest<unknown>): boolean {
    if (request.headers.has('Authorization')) {
      return true;
    }
    const url = request.url.toLowerCase();
    const skipSubstrings = [
      '/auth/login',
      '/auth/register',
      '/auth/validate-password-code',
      '/auth/reset-password',
      '/validatetemporarypasswordlogin',
      '/changepasswordaftertemporary',
      'viacep.com.br',
      // Upload/download direto no Blob com SAS — JWT no Authorization quebra a assinatura.
      'blob.core.windows.net',
    ];
    return skipSubstrings.some((s) => url.includes(s));
  }
}
